import { createContext } from 'react';
import { ContextWrapper } from '../../config/constants';
import { TradeActions, TradeStateType } from './tradeTypes';

const tradeContext = createContext({} as ContextWrapper<TradeStateType, TradeActions>);
tradeContext.displayName = 'TradeContext';

export default tradeContext;
